import { useRef } from "react";
import { useCartProducts, useCombinedProductData } from "@design-lab/entities/product";
import { useCompositionPricing, useCurrentComposition } from "@design-lab/entities/composition";
import { ProductPricing } from "@design-lab/features/manage-product-sizing/ui/ProductPricing";
import { AddToCartToolbar } from "@design-lab/features/add-to-cart";
import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { usePriceExposedTracking } from "@design-lab/shared/hooks/usePriceExposedTracking";

export function AddToCart() {
  const { shirtCount } = useCartProducts();
  const { isLoading } = useCombinedProductData();
  const { totalPriceWithBulkDiscount, savings } = useCompositionPricing();
  const { isMobile } = useResponsive();
  const { currentProduct } = useCurrentComposition();

  const priceRef = useRef<HTMLDivElement>(null);

  usePriceExposedTracking(
    priceRef,
    {
      component: "ProductPricing",
      step: "DesignLab",
      priceShown: totalPriceWithBulkDiscount,
      catalogNumber: currentProduct?.catalogNumber,
      quantity: shirtCount,
      businessLine: "print"
    },
    !isMobile && shirtCount > 0 && totalPriceWithBulkDiscount > 0
  );

  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:pt-0">
      {!isMobile && (
        <div ref={priceRef}>
          <ProductPricing
            isLoading={isLoading}
            salePrice={totalPriceWithBulkDiscount}
            savings={savings}
            shirtCount={shirtCount}
          />
        </div>
      )}

      <AddToCartToolbar />
    </div>
  );
}
